/**
 * Plano Gratuito (MAN-364): barra de contagem de lançamentos, barra de limite
 * atingido e bloqueio das telas de lançar.
 *
 * A regra de verdade fica no backend (`SubscriptionsService.getTransactionUsage`):
 * a tela só mostra o que a API devolve em `/subscriptions/my/usage`.
 */

/** Todos os "Fazer upgrade" do plano Gratuito levam ao WhatsApp do Financeiro Diário. */
export const UPGRADE_WHATSAPP_URL =
    'https://wa.me/5511955026303?text=Estou%20no%20Plano%20Gratuito%20e%20quero%20fazer%20o%20upgrade%20do%20Financeiro%20Di%C3%A1rio';

export type VarianteBarraGratuito = 'contagem' | 'limite';

/** Qual barra mostrar: a de contagem enquanto há saldo, a de limite ao atingir. */
export function varianteDaBarra(atingiu: boolean): VarianteBarraGratuito {
    return atingiu ? 'limite' : 'contagem';
}

/** Percentual usado (0 a 100) para a barra de progresso. */
export function percentualUsado(usados: number, limite: number | null | undefined): number {
    if (!limite || limite <= 0) return 0;
    const pct = (Math.max(usados, 0) / limite) * 100;
    return Math.min(100, Math.round(pct));
}

/**
 * Chave do "fechar" da barra no sessionStorage. Cada variante tem a sua: fechar a
 * de contagem não esconde a de limite atingido quando ela aparecer.
 */
export function chaveBarraFechada(variante: VarianteBarraGratuito): string {
    return `planoGratuito:barraFechada:${variante}`;
}
